import { jsx as _jsx } from "react/jsx-runtime";
import { LightbulbIcon } from '@yonderland/andes-icons';
import { Banner, Box } from '@yonderland/andes-react';
import AsNumeral from '../../../vendors/asNumeral';
const MESSAGE_AMOUNT_TEMPLATE = '{{{AMOUNT}}}';
const ClosenessQualifier = ({ amountUntilFreeDelivery, currency, totalPriceSell, showProgressBar, freeDeliveryMessage, }) => {
    const getText = () => {
        return freeDeliveryMessage.replace(MESSAGE_AMOUNT_TEMPLATE, `${currency}${AsNumeral.formatAsCurrency(amountUntilFreeDelivery)}`);
    };
    return (_jsx(Box, { backgroundColor: "informative-bg", marginInline: { base: '-4', md: '-4', lg: '0' }, paddingInline: { md: '2', lg: '4' }, children: _jsx(Banner, { progress: showProgressBar ? (totalPriceSell / (totalPriceSell + amountUntilFreeDelivery)) * 100 : undefined, icon: { source: LightbulbIcon }, status: "informative", text: getText() }) }));
};
export default ClosenessQualifier;
